import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import AgencyProducerForm from './AgencyProducerForm'
import AgencyProducerCard from './AgencyProducerCard'

import Resource from '../../stores/resource'
const AgProducerStore = Resource('agency-producers')

class NewAgencyProducer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agencyProducer: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    // Adjust attributes
    attributes.phones = {
      office: attributes.officePhone,
      mobile: attributes.mobilePhone
    }
    attributes.companyId = attributes.agencyId // TODO: fix this server-side
    // Remove display-only fields
    delete attributes.agencyName
    delete attributes.mobilePhone
    delete attributes.officePhone
    // Build new full name
    const newFullName = `${attributes.firstName} ${attributes.lastName}`
    // Create!
    AgProducerStore.create(attributes)
    .then((result) => {
      // We need to do another query to get included objects
      const agencyProducer = result.data.data
      AgProducerStore.findBy({id: agencyProducer.id}, ['agency'])
      .then((savedAgencyProducer) => {
        this.setState({
          saved: true,
          error: '',
          savedAgencyProducer: savedAgencyProducer.data,
          snackbarMessage: `External project manager "${newFullName}" created!`
        },
        () => {
          if (this.props.savedCallback) {
            this.props.savedCallback(this.state.savedAgencyProducer)
          }
        })
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/agency-producers`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const agencyProducer = this.state.agencyProducer
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <AgencyProducerForm
          formTitle={this.props.formTitle}
          firstName={agencyProducer.firstName}
          lastName={agencyProducer.lastName}
          title={agencyProducer.title}
          email={agencyProducer.email}
          address={agencyProducer.address}
          city={agencyProducer.city}
          province={agencyProducer.province}
          postalCode={agencyProducer.postalCode}
          country={agencyProducer.country}
          phones={agencyProducer.phones}
          agencyId={agencyProducer.agencyId}
          agencyName={agencyProducer.agencyName}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create external project manager">
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(this.state.saved)}
            title="AgencyProducer created">
            <p>
              A new external project manager has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <AgencyProducerCard
              agencyProducer={this.state.savedAgencyProducer}
              editCallback={() => this._redirectTo(`/agency-producers/${this.state.savedAgencyProducer.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewAgencyProducer



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/NewAgencyProducer.jsx